import React from 'react';
import { CaseDocument } from '../../services/api';
import FileTree from '../FileTree/FileTree';
import { Upload as UploadIcon } from 'lucide-react';
import './DocumentsTab.css';

interface DocumentsTabProps {
  documents: CaseDocument[];
  onUploadDocument: () => void;
  onDownload: (docId: string) => void;
  onPreview: (docId: string) => void;
  formatFileSize: (bytes: number) => string;
  formatDate: (date: string) => string;
}

const DocumentsTab: React.FC<DocumentsTabProps> = ({
  documents,
  onUploadDocument,
  onDownload,
  onPreview,
  formatFileSize,
  formatDate,
}) => {
  return (
    <div className="documents-list">
      <div className="documents-header">
        <button onClick={onUploadDocument} className="upload-doc-btn">
          <UploadIcon size={18} />
          Upload Document
        </button>
      </div>
      {documents ? (
        <FileTree
          documents={documents
            .filter((doc) => doc.docId)
            .map((doc) => ({
              docId: doc.docId!,
              fileName: doc.fileName,
              fileType: doc.fileType || doc.mimeType || '',
              fileSize: doc.fileSize,
              uploadDate: doc.uploadDate || doc.uploadedAt || '',
              uploaderName: doc.uploaderName || doc.uploadedBy || 'Unknown',
            }))}
          formatFileSize={formatFileSize}
          formatDate={formatDate}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      ) : (
        <div className="empty-state">No documents available</div>
      )}
    </div>
  );
};

export default DocumentsTab;

